
<div class="keep-offer-dialog">

  <div class="content">

    <h1> {{isNewOffer ? "Créer offre de services"  : "Mettre à jour offre" }}</h1>
    <!-- car: {{keepOffer.carId}}, <br />
    offer: {{keepOffer.offerId}}, <br />
    line: {{keepOffer.businessLine}} <br />
    d line: {{data.businessLine}} -->
    <form #offerEditForm="ngForm" class="offer-edit-form">
      <div hidden>
        <mat-form-field >
          <input type="text" matNativeControl matInput="" name ="id" placeholder="Id"  [(ngModel)] = "keepOffer.offerId" >
        </mat-form-field>
      </div >
      <!--
      <span *ngIf="keepOffer.offerId === ''">


        <mat-form-field >
          <mat-label>Marque</mat-label>
          <mat-select required name = "make" (selectionChange)="onMakeChange($event.value)" [(ngModel)]="selectedMake">
            <mat-option *ngFor="let make of (makes$ | async)!; index as i" [value]="make" >{{make.name}}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field *ngIf="keepOffer.make !=''" >
          <mat-label>Modele</mat-label>
          <mat-select matNativeControl required name = "model" [disabled]="!(selectedMake.id>0)" (selectionChange)="onModelChange($event.value)" [(ngModel)]="selectedModel">
            <mat-option *ngFor="let model of (models$ | async)!;" [value]="model"> {{model.makeName}}  {{model.name}} </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field *ngIf="keepOffer.make !=''" >
          <mat-label>Version</mat-label>
          <mat-select matNativeControl required name = "version" [disabled]="!(selectedModel.id>0)" (selectionChange)="onVersionChange($event.value)" [(ngModel)]="selectedVersion">
            <mat-option *ngFor="let version of (versions$ | async)!;" [value]="version"> {{version.makeName}}  {{version.modelName}}  {{version.name}} </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field *ngIf="keepOffer.version !=''" >
          <mat-label>Motorisation</mat-label>
          <mat-select matNativeControl required name = "engine" [disabled]="!(selectedVersion.id>0)" (selectionChange)="onEngineChange($event.value)" [(ngModel)]="selectedEngine">
            <mat-option *ngFor="let engine of selectedVersion.engines" [value]="engine"> {{engine.id}} - {{engine.ref}}  {{engine.name}}  {{engine.powerHp}} CV </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field *ngIf="keepOffer.version!=''">
          <mat-label>Features</mat-label>
          <mat-select multiple matNativeControl name = "features" [(ngModel)] = "keepOffer.features">
            <mat-option *ngFor="let feature of ( features$ | async)!;" [value]="feature.name"> {{feature.code}} - {{feature.name}} </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field *ngIf="keepOffer.model!=''">
          <mat-label >Carburant</mat-label>
          <mat-select required  name="fuel"  [(ngModel)]="keepOffer.fuel" >
            <mat-option *ngFor="let fuel of carFuels; index as i" [value]="fuel" >{{fuel}}</mat-option>
          </mat-select>

        </mat-form-field>


        <mat-form-field *ngIf="keepOffer.fuel.valueOf() !='' ">
          <mat-label>Boite</mat-label>
          <mat-select required  name="gearbox"  [(ngModel)]="keepOffer.gearBox" >
            <mat-option *ngFor="let gear of carGearBoxes; index as i" [value]="gear" >{{gear}}</mat-option>
          </mat-select>

        </mat-form-field>

        <mat-form-field *ngIf="keepOffer.gearBox.valueOf() != ''">
          <mat-label>Année</mat-label>
          <mat-select matNativeControl required name = "year" [(ngModel)] = "keepOffer.year">
            <mat-option *ngFor="let year of carYearsBD;" [value]="year"> {{year}} </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field *ngIf="keepOffer.year > 0">
          <mat-label>Kilometrage</mat-label>
          <input type="number" required matInput="" name ="mileage" step="1000" placeholder="mileage"  [(ngModel)] = "keepOffer.mileage" >
        </mat-form-field>

      </span>
      -->

      <mat-form-field>
        <mat-label>Pays</mat-label>
        <mat-select required  name="country" (selectionChange)="updateCitiesBD(keepOffer.country);" [(ngModel)]="keepOffer.country" >
          @for (country of countryCodeOptions; track country; let i = $index) {
            <mat-option [value]="country" >{{getCountry(country).name}}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Ville </mat-label>
        <mat-select matNativeControl [disabled]="keepOffer.country===''" required name = "city" [(ngModel)]="keepOffer.city">
          @for (city of citiesBD; track city; let i = $index) {
            <mat-option [value]="city"> {{getCity(city)}} </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field required>
        <mat-label>Titre</mat-label>
        <input type="text" matInput="" name ="offerTitle" placeholder="Titre"  [(ngModel)] = "keepOffer.offerTitle" >
      </mat-form-field>

      <mat-form-field required>
        <mat-label >Description</mat-label>
        <textarea matInput type="text" name ="offerDescription" placeholder="Description"  [(ngModel)]="keepOffer.offerDescription" ></textarea>
      </mat-form-field>

      <mat-form-field >
        <mat-label>Services fournis</mat-label>
        <mat-select multiple  matNativeControl  name = "servicesProvided" [(ngModel)]="keepOffer.servicesProvided">
          @for (serv of servicesTypes; track serv) {
            <mat-option [value]="serv.code"> {{serv.title}} </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Catégorie de prestations</mat-label>
        <mat-select name="jobCategories" multiple [(ngModel)]="keepOffer.jobCategories" required>
          @for (serv of jobCategoriesBD; track serv) {
            <mat-option [value]="serv.code" >{{serv.title}}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field >
        <mat-label>Spécialités (marques)</mat-label>
        <mat-select multiple matNativeControl  name = "specialtyMakes" [(ngModel)]="keepOffer.specialtyMakes">
          @for (mk of allMakes; track mk) {
            <mat-option [value]="mk"> {{mk}} </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field >
        <mat-label>Latitude</mat-label>
        <input type="number" matInput="" name ="latitude"  [(ngModel)]="keepOffer.geoLocation.latitude">
      </mat-form-field>

      <mat-form-field >
        <mat-label>Longitude</mat-label>
        <input type="number" matInput="" name ="longitude"  [(ngModel)]="keepOffer.geoLocation.longitude">
      </mat-form-field>




      <!--
      <mat-form-field *ngIf = "keepOffer.model !=''">
        <input type="text" matInput="" name ="variant" placeholder="Variant"  [(ngModel)] = "keepOffer.variant" >
      </mat-form-field>

      <mat-form-field *ngIf = "keepOffer.id !=''">
        <input type="text" matInput="" name ="id" placeholder="Id"  [(ngModel)] = "keepOffer.id" >
      </mat-form-field>


      <p *ngIf = "updateMode">
        <label id="example-radio-group-label">Body Type</label>
        <br />
        <mat-radio-group
          aria-labelledby="example-radio-group-label" class="example-radio-group" name="bodyType" [(ngModel)] = "keepOffer.bodyType">
          <mat-radio-button class="example-radio-button" *ngFor="let type of carBodyTypes; index as i"  [value]="type">
            {{type}}
          </mat-radio-button>
        </mat-radio-group>

      </p>


      <p style="color: orange">{{ formMessage }} </p>
      -->

      <!--
      <p> {{!updateMode ? "Create new keepOffer"  : "Update keepOffer Infos" }}
        <button (click) = "toggleMode()" class="link" >{{updateMode ? "Show body type"  : "Hide body type" }}</button>

      </p>
      -->

    </form>

    <div class="action-buttons">
      <button class="simple-button-keep" mat-button [mat-dialog-close]="">Annuler</button>
      <button class="cta-button-keep" [disabled]=!offerEditForm.valid mat-button [mat-dialog-close]="keepOffer" (click)="submitKeepOffer();$event.stopPropagation()">
        Enregistrer
      </button>
    </div>

  </div>
  <!--
  <div mat-dialog-actions>
    <button class ="simple-button" mat-button [mat-dialog-close]="">Annuler</button>
    <button class ="cta-button-{{keepOffer.businessLine.toLowerCase()}}" [disabled] = !offerEditForm.valid mat-button [mat-dialog-close]="keepOffer" cdkFocusInitial> {{isNewOffer ? "Créer"  : "Enregistrer " }} </button>
  </div> -->
</div>


